// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./ChartSettingsErrorButton";
